import CityPageTemplate from "../city-template/CityPageTemplate";
import { napervilleConfig } from "./data";

export default function NapervillePage() {
  return <CityPageTemplate config={napervilleConfig} />;
}